import {httpIncidentAPI} from 'features/http/api/httpIncidentAPI';
import {ILastIncidents} from 'entities/monitor';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IHttpIncident from './HttpIncident/IHttpIncident';

export const useLastHttpIncidents = (limit: number): ILastIncidents<IHttpIncident> => {
    const {data: pagination, isLoading, isFetching} = httpIncidentAPI.useGetHttpIncidentsQuery(
        {limit},
        {pollingInterval: getPollingInterval()},
    );

    return {pagination, isLoading, isFetching};
};

export default useLastHttpIncidents;
